module.exports = __webpack_public_path__ + "img/gj9.5cffacb0.png";